import { cva } from "class-variance-authority";

// Shared tokens — update here to keep Input and InputGroup in sync
const borderBase =
  "border-gray-300 transition-colors outline-hidden border rounded-sm";
const sizeClasses = "h-12 w-full min-w-0";
const hoverBorder =
  "hover:border-primary/30 group-data-[invalid=true]/field:hover:border-red";
export const inputFocusBorderStatic = "border border-primary";
const focusBorder = "focus-visible:border focus-visible:border-primary";
export const inputErrorBorderStatic = "border border-red";
const errorClasses =
  "group-data-[invalid=true]/field:border group-data-[invalid=true]/field:border-red";

export const inputVariants = cva([
  // border
  borderBase,
  sizeClasses,
  // layout & typography
  // typography: input value style — design-system primitive contract, not a heading
  "bg-transparent px-4 py-0 text-base font-semibold text-black",
  hoverBorder,
  // focus border
  focusBorder,
  // error / invalid state
  errorClasses,
]);

// Variant for InputGroup wrapper — same visual tokens but focus is detected
// via has-[] because the focusable control is a child element
export const inputGroupVariants = cva([
  // border
  borderBase,

  // layout & shape
  sizeClasses,
  "relative flex items-center",
  hoverBorder,
  // focus border — triggered when inner control is focused (border width from borderBase)
  "has-[[data-slot=input-group-control]:focus-visible]:border-primary",
  // error / invalid state — same as Input
  errorClasses,
  // also support aria-invalid on inner control (standalone usage without Field)
  "has-[[data-slot][aria-invalid=true]]:border-red",
  "has-[[data-slot][aria-invalid=true]]:hover:border-red",
]);
